import i18n from '@plug/i18n';
import * as Yup from 'yup';
import { getHublyFormUnmaskedValue } from './hubly-form';

export const YUP_VALIDATIONS = {
  // Personal data
  name: Yup.string()
    .test(
      'first-last-name',
      i18n.t('hubly-dashboard.commons.form.errors.first-last-name'),
      (value: string) => {
        const splited = value?.trimEnd()?.split(' ') || [];
        return splited.length >= 1 && splited.every(namePart => namePart?.length >= 1);
      },
    )
    .required(i18n.t('hubly-dashboard.commons.form.errors.commons.required')),
  birthday: Yup.string()
    .matches(
      new RegExp(/^\d{2}\/\d{2}\/\d{4}$/),
      i18n.t('hubly-dashboard.commons.form.errors.birth-date'),
    )
    .required(i18n.t('hubly-dashboard.commons.form.errors.commons.required')),
  email: Yup.string()
    .email(i18n.t('hubly-dashboard.commons.form.errors.email'))
    .required(i18n.t('hubly-dashboard.commons.form.errors.commons.required')),
  role: Yup.string() /* .required(i18n.t('hubly-dashboard.commons.form.errors.commons.required'))*/,
  phone: Yup.string(),
  gender: Yup.string().required(i18n.t('hubly-dashboard.commons.form.errors.commons.required')),
  document: Yup.string()
    .matches(
      new RegExp(
        /([0-9]{2}[\.]?[0-9]{3}[\.]?[0-9]{3}[\/]?[0-9]{4}[-]?[0-9]{2})|([0-9]{3}[\.]?[0-9]{3}[\.]?[0-9]{3}[-]?[0-9]{2})/,
      ),
      i18n.t('hubly-dashboard.commons.form.errors.document'),
    )
    .required(i18n.t('hubly-dashboard.commons.form.errors.commons.required')),

  // Password (login)
  passwordLogin: Yup.string().required(
    i18n.t('hubly-dashboard.commons.form.errors.commons.required'),
  ),

  // Password (change password)
  passwordChangePassword: Yup.string()
    .matches(
      new RegExp(/^(?=.*[0-9])(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/),
      i18n.t('hubly-dashboard.commons.form.errors.password.match'),
    )
    .required(i18n.t('hubly-dashboard.commons.form.errors.commons.required')),

  passwordChangeNewPassword: Yup.string()
    .matches(
      new RegExp(/^(?=.*[0-9])(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/),
      i18n.t('hubly-dashboard.commons.form.errors.password.match'),
    )
    .required(i18n.t('hubly-dashboard.commons.form.errors.commons.required')),

  passwordChangeNewPasswordConfirmation: Yup.string()
    .oneOf(
      [Yup.ref('passwordConfirmation')],
      i18n.t('hubly-dashboard.commons.form.errors.confirm-password'),
    )
    .required(i18n.t('hubly-dashboard.commons.form.errors.commons.required')),

  // Password (onboarding or recovery)
  password: Yup.string()
    .matches(
      new RegExp(/^(?=.*[A-Z])(?=.*[0-9])(?=.*[a-z]).{8,}$/),
      i18n.t('hubly-dashboard.commons.form.errors.password.match'),
    )
    // .min(8, i18n.t('hubly-dashboard.commons.form.errors.password.min'))
    .required(i18n.t('hubly-dashboard.commons.form.errors.commons.required')),

  passwordConfirmation: Yup.string()
    .oneOf([Yup.ref('password')], i18n.t('hubly-dashboard.commons.form.errors.confirm-password'))
    .required(i18n.t('hubly-dashboard.commons.form.errors.commons.required')),

  firstName: Yup.string().required(i18n.t('hubly-dashboard.commons.form.errors.commons.required')),

  lastName: Yup.string().required(i18n.t('hubly-dashboard.commons.form.errors.commons.required')),

  // Address
  cep: Yup.string().required(i18n.t('hubly-dashboard.commons.form.errors.commons.required')),
  street: Yup.string().required(i18n.t('hubly-dashboard.commons.form.errors.commons.required')),
  number: Yup.number().required(i18n.t('hubly-dashboard.commons.form.errors.commons.required')),
  complement: Yup.string(),
  neighbourhood: Yup.string().required(
    i18n.t('hubly-dashboard.commons.form.errors.commons.required'),
  ),
  city: Yup.string().required(i18n.t('hubly-dashboard.commons.form.errors.commons.required')),
  state: Yup.string().required(i18n.t('hubly-dashboard.commons.form.errors.commons.required')),

  // Bank informations
  bank: Yup.string().required(i18n.t('hubly-dashboard.commons.form.errors.commons.required')),
  bankType: Yup.string().required(i18n.t('hubly-dashboard.commons.form.errors.commons.required')),
  account: Yup.string()
    .required(i18n.t('hubly-dashboard.commons.form.errors.commons.required'))
    .test(
      'not-zero',
      i18n.t('hubly-dashboard.commons.form.errors.commons.invalidValue'),
      value => value !== '0',
    ),
  accountDigit: Yup.string().required(
    i18n.t('hubly-dashboard.commons.form.errors.commons.required'),
  ),
  accountHolderName: Yup.string().required(
    i18n.t('hubly-dashboard.commons.form.errors.commons.required'),
  ),
  agency: Yup.string()
    .required(i18n.t('hubly-dashboard.commons.form.errors.commons.required'))
    .test(
      'not-zero',
      i18n.t('hubly-dashboard.commons.form.errors.commons.invalidValue'),
      value => value !== '0',
    ),

  // Useful
  code: Yup.string()
    .min(6, i18n.t('hubly-dashboard.commons.form.errors.code'))
    .required('Preencha com o código recebido.'),

  // Organization registration
  organization_name: Yup.string().required(
    i18n.t('hubly-dashboard.commons.form.errors.commons.required'),
  ),
  cnpj: Yup.string()
    .matches(
      new RegExp(/^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/),
      i18n.t('hubly-dashboard.commons.form.errors.document-cnpj'),
    )
    .required(i18n.t('hubly-dashboard.commons.form.errors.commons.required')),
  organization_phone: Yup.string(),
  organization_type: Yup.string().required(
    i18n.t('hubly-dashboard.commons.form.errors.commons.required'),
  ),
  url: Yup.string()
    .matches(
      new RegExp(/^(https:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/),
      'Informe uma URL válida',
    )
    .required(i18n.t('hubly-dashboard.commons.form.errors.commons.required')),

  urlWithDomain: (domain: string): Yup.StringSchema<string> =>
    Yup.string()
      .matches(
        new RegExp(/^(https:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/),
        'Informe uma URL válida (https://www.exemplo.com)',
      )
      .test('domain', `Por favor, utilize apenas URLs da sua loja (${domain})`, value => {
        if (value) {
          return value?.includes(domain);
        }

        return true;
      })
      .required(i18n.t('hubly-dashboard.commons.form.errors.commons.required')),

  emailInviteTeammates: (length: number, PlanNumber: number): Yup.StringSchema<string> =>
    Yup.string()
      .test(
        'PlanNumber',
        `Você pode convidar até ${PlanNumber} administradores para a sua organização.`,
        () => {
          if (length < PlanNumber) {
            return true;
          }

          return false;
        },
      )
      .email(i18n.t('hubly-dashboard.commons.form.errors.email'))
      .required(i18n.t('hubly-dashboard.commons.form.errors.commons.required')),

  holderName: Yup.string().required(i18n.t('hubly-dashboard.commons.form.errors.commons.required')),

  cardNumber: (validator: (field: string) => boolean) =>
    Yup.string()
      .required(i18n.t('hubly-dashboard.commons.form.errors.commons.required'))
      .test('cardNumber', 'Cartão de crédito inválido', value =>
        !value ? true : validator(value),
      ),
  cardDueDate: (validator: (field: string) => boolean) =>
    Yup.string()
      .required(i18n.t('hubly-dashboard.commons.form.errors.commons.required'))
      .test('cardDueDate', 'Data de vencimento inválida', value =>
        !value ? true : validator(value),
      ),
  cardCVV: Yup.string().required(i18n.t('hubly-dashboard.commons.form.errors.commons.required')),

  coupon: Yup.string().required(i18n.t('hubly-dashboard.commons.form.errors.commons.required')),

  maskRequired: (name: string) =>
    Yup.string().test(
      name,
      i18n.t('hubly-dashboard.commons.form.errors.commons.required'),
      (value = '') => {
        if (!value) return false;

        const unmasked = getHublyFormUnmaskedValue(value);

        return !!unmasked;
      },
    ),
  termsAndPolitics: Yup.boolean().oneOf(
    [true],
    i18n.t('hubly-dashboard.commons.form.errors.commons.required'),
  ),
};
